<template>
  <div v-if="route.query.redirect" class="goToModule" @click="router.back()"><i class="material-icons">keyboard_arrow_left</i>Volver</div>
  <router-link v-else :to="`/course/${route.params.courseId}/module/${route.params.moduleId}`" class="goToModule"> <i class="material-icons-outlined">chevron_left</i> Volver al módulo</router-link>  
  <EmptyState v-if="moduleLocked" :icon="'event'" :title="'Este contenido no se encuentra disponible aún'" :message="`<span>Podrás visualizarlo a partir del <strong>${moduleLockedDate}</strong><br>Si quieres ver más material, te invitamos a que recorras los distintos artículos, podcast y charlas que hemos seleccionado para ti en la sección <a href=/resources style=color:#9E5498;font-weight:600;>Recursos</a></span>`" :color="'pink'"/>
  <Loader v-else-if="!dataLoaded && !moduleLocked" />
  <template v-else>
    <div class="module_muro__title">
      <span class="module_muro__title-activity">{{ $t('course.modules.muro.TITLE') }}</span>
      <p class="module_muro__title-date">
        <span
        v-if="forumData && forumData.isMandatory"
        ><i class="material-icons-outlined">error</i> {{ $t('moduleMuro.MANDATORY_ACTIVITY') }}</span>
        <span
        v-else
        ><i class="material-icons-outlined">error</i> {{ $t('moduleMuro.OPTIONAL_ACTIVITY') }}</span>
        <span v-if="forumData.displayEndDate">{{ $t('global.DELIVERY_DATE') }} {{ forumData.displayEndDate }}</span>
      </p>
    </div>
    

    <div class="module-muro-content" v-html="forumData.data.Data"></div>


    <div v-if="forumData && forumData.courseIsFinished" class="courseIsFinished">
        <i class="material-icons">error</i>
        <span>
          <strong>{{ $t('course.status.COURSE_FINISHED') }}</strong><br/>
          <p>{{$t('commentsWall.instructions.COURSE_FINISHED')}}</p>
        </span>
    </div>
  
    <!-- show only if columns > 1 and ismobile -->
    <div class="commentsWall__swipe"
      v-if="data.length > 1 && isMobile"
    >
        <i class="material-icons">swipe_left</i>
        <span>{{ $t('moduleMuro.SWIPE_LEFT_TO_SEE_TOPICS') }}</span>
    </div>
  
    <div class="module_muro_container"
      v-dragscroll:nochilddrag="!isMobile"
      :class="[
          user.permissions.includes('CURSO_ACTIVIDAD_AVANCE') ? 'module_muro_container--tutor' : '',
          expandModule ? 'module_muro_container--tutor--expanded' : ''
      ]"
    >
      <div class="module_muro"
        v-dragscroll:nochilddrag="!isMobile"
        >
        <div data-dragscroll
        v-for="(column, idx) in data" 
        :key="idx" class="module_muro__column">
          <h2 class="module_muro__header" data-dragscroll>{{ column.header.subject }}</h2>
        </div>
      </div>

      <div 
        class="module_muro"
        v-dragscroll:nochilddrag="!isMobile"
      >
        <!-- COLUMNAS -->
        
        <div data-dragscroll
          v-for="(column, idx) in data" 
          :key="idx" 
          class="module_muro__column"
        >
          <!--<h2 class="module_muro__header" data-dragscroll>{{ column.header.subject }}</h2>-->
          <button @click="activateCommentBox(idx)" class="module_muro__addComment" v-if="forumData && !forumData.courseIsFinished">
            {{ $t('moduleMuro.ADD_REFLECTION') }} <i class="material-icons">add_comment</i>
          </button>
    
          <!-- EDITOR DE TEXTO -->
          <Transition name="fade">
            <div v-if="activeCommentBox === `${idx}`" class="module_muro__comment">
              <link-preview
                :editMode="true"
                @generated="(data)=> newHeaderLink = data"
                @delete="newHeaderLink = null"
              />
              <VueEditor
                v-model="newHeaderComment"
                :editor-toolbar="customToolbar"
                :editorOptions="editorSettings"
                @image-added="handleImageAdded"
                :id="`newComment--${idx}`"
              />
              <div style="display: flex; align-items: center; justify-content: center; gap: 12px;">
                <button @click="enableTextBox[idx] = false; activeCommentBox=null;" class="module_muro__button--cancel">{{ $t('global.CANCEL') }}</button>

                <button
                  :disabled="sendingComment" 
                  @click="handleComment(idx);" 
                  class="module_muro__button--submit"
                >
                  {{ $t('global.PUBLISH') }}
                </button>

              </div>
            </div>
          </Transition>
          
          <!-- COMENTARIOS -->
          <div v-for="(comment, idxComment) in column.comments" :key="idxComment">
            <div class="module_muro__comment">
              <div style="display: flex; align-items: center; justify-content: space-between; width: 100%; ">
                <span class="module_muro__name">
                  <strong>{{ comment.userName }}</strong>
                  {{ comment.whenCreated.quantity }} {{ $t(`date.params.${comment.whenCreated.param}`) }}
                </span>
                <div @click="addClickOutside(`comment__container_${comment.id}`)" v-if="comment.canEdit && !comment.isDeleted" class="dropdown">
                    <input type="checkbox" :id="`comment__container_${comment.id}`">
                    <label class="dropdown__face" :for="`comment__container_${comment.id}`">
                        <span class="material-icons">more_horiz</span>
                    </label>
                    <ul class="dropdown__items">    
                        <li 
                          @click="deleteCommentModel.id=comment.id; deleteCommentModel.idx=idxComment; modalDelete=true; deleteCommentModel.headerIdx = idx ; commentForDelete = comment" 
                          class="material-icons" 
                        >
                          delete
                        </li>                                 
                        <li @click="newHeaderComment = comment.comment; newHeaderLink = comment.link[0] ;comment.editEnabled = true" class="material-icons" >edit</li>                                 
                        <li @click="hiddeModalOptions(`comment__container_${comment.id}`)" class="material-icons" >close</li>                                 
                    </ul>
                </div>
              </div>
              <span v-if="comment.isDeleted" class="module_muro__content--deleted">
                {{ $t('moduleMuro.COMMENT_DELETED') }}
              </span>

              <div v-else-if="comment.editEnabled" class="module_muro__comment" style="padding: 0;">
                <link-preview
                  :editMode="true"
                  :data="comment.link[0]"
                  @generated="(data)=> newHeaderLink = data"
                  @delete="newHeaderLink = null"
                />
                <VueEditor 
                  v-model="newHeaderComment"
                  :editor-toolbar="customToolbar"
                  :editorOptions="editorSettings"
                  :id="`newComment--${idx}--${idxComment}--edit`"
                />
                <div style="display: flex; align-items: center; justify-content: center; gap: 12px;">
                  <button @click="comment.editEnabled = false; newHeaderComment = ''" class="module_muro__button--cancel">Cancelar</button>
                  <button :disabled="sendingComment" @click="handleEdit(comment);" class="module_muro__button--submit">Publicar</button>
                </div>
              </div>
              <template v-else>
                <link-preview v-if="!sendingComment"
                  :editMode="false"
                  :data="comment.link[0]"
                />
                <p class="module_muro__content" v-html="comment.comment"></p>
              </template>
            </div>
            <div class="module_muro__buttons">

              <button 
                @click="handleLike(comment.id, comment.isLikedByUser, idx)" 
                :class="`${comment.isLikedByUser ? 'module_muro__buttons--active' : ''}`"
              >
                <i class="material-icons-outlined">{{ comment.isLikedByUser ? 'favorite' : 'favorite_border' }}</i> 
                {{ $t('moduleMuro.LIKE') }} ({{ comment.likesQuantity }})
              </button>

              <button 
                @click="enableTextBox[`${idx}--${idxComment}`] = enableTextBox[`${idx}--${idxComment}`] ? false : true" 
              >
                <i class="material-icons-outlined">comment</i> {{ $t('moduleMuro.REPLY') }}
              </button>

              <button 
                @click="fetchCommentsAnswers(idx, idxComment)" 
                v-if="comment.repliesQuantity > 0"
                :disabled="loadingMoreComments[`${idx}--${idxComment}`]" 
              >
                <i class="material-icons-outlined">{{ viewComments[`${idx}--${idxComment}`] ? 'visibility_off' : 'visibility'}}</i> 
                {{ viewComments[`${idx}--${idxComment}`] ? $t('moduleMuro.HIDE') : $t('moduleMuro.SHOW') }} {{ $t('moduleMuro.RESPONSES') }} ({{ comment.repliesQuantity }})
              </button>

            </div>
            <!-- CAJA DE TEXO PARA EL COMENTARIO  -->
            <Transition name="fade" >
              <div v-if="enableTextBox[`${idx}--${idxComment}`]" class="module_muro__comment">
                <link-preview
                  :editMode="true"
                  @generated="(data)=> newHeaderLink = data"
                  @delete="newHeaderLink = null"
                />
                <VueEditor 
                  v-model="newHeaderComment"
                  :editor-toolbar="customToolbar"
                  :editorOptions="editorSettings"
                  :id="`newComment--${idx}--${idxComment}`"
                />
                <div style="display: flex; align-items: center; justify-content: center; gap: 12px;">
                  <button @click="enableTextBox[`${idx}--${idxComment}`] = false" class="module_muro__button--cancel">Cancelar</button>
                  <button :disabled="sendingComment" @click="handleComment(idx, comment.id, idxComment);" class="module_muro__button--submit">Publicar</button>
                </div>
              </div>
            </Transition>
    
            <!-- COMENTARIOS HIJOS -->
            <template v-if="viewComments[`${idx}--${idxComment}`]">
              <div v-for="(answer, answeridx) in comment.comments?.data" :key="answeridx" style="padding-top: 12px;" class="module_muro__childrenComment">
                <div class="module_muro__childrenComment_lines" >
                  <div class="module_muro__childrenComment_line1"></div>
                  <div v-if="answeridx + 1 < comment.comments?.data.length" class="module_muro__childrenComment_line2"></div>
                </div>
                <div class="module_muro__childrenComment_container">
                  <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;" >
                    <span class="module_muro__childrenComment_name">
                      <strong>{{ answer.userName }}</strong>
                      {{ answer.whenCreated.quantity }} {{ $t(`date.params.${answer.whenCreated.param}`) }}
                    </span>
                    <div @click="addClickOutside(`comment__container_${answer.id}`)" v-if="answer.canEdit" class="dropdown">
                        <input type="checkbox" :id="`comment__container_${answer.id}`">
                        <label class="dropdown__face" :for="`comment__container_${answer.id}`">
                            <span class="material-icons">more_horiz</span>
                        </label>
                        <ul class="dropdown__items">    
                            <li 
                              @click="deleteCommentModel.id = answer.id; deleteCommentModel.idx = answeridx; modalDelete = true; deleteCommentModel.headerIdx = idx; commentForDelete = answer; deleteCommentModel.parentIdx = idxComment" 
                              class="material-icons" 
                            >
                              delete
                            </li>                                 
                            <li @click="newHeaderComment = answer.comment; newHeaderLink = answer.link[0] ;answer.editEnabled = true" class="material-icons" >edit</li>                          
                            <li @click="hiddeModalOptions(`comment__container_${answer.id}`)" class="material-icons" >close</li>                                 
                        </ul>
                    </div>
                  </div>
                  <span v-if="answer.isDeleted" class="module_muro__content--deleted">
                    Este comentario ha sido eliminado.
                  </span>
                  <div v-else-if="answer.editEnabled" class="module_muro__comment" style="padding: 0;">
                    <link-preview
                      :editMode="true"
                      :data="answer.link[0]"
                      @generated="(data)=> newHeaderLink = data"
                      @delete="newHeaderLink = null"
                    />
                    <VueEditor 
                      v-model="newHeaderComment"
                      :editor-toolbar="customToolbar"
                      :editorOptions="editorSettings"
                      :id="`newComment--${idx}--${answeridx}--edit`"
                    />
                    <div style="display: flex; align-items: center; justify-content: center; gap: 12px;">
                      <button @click="answer.editEnabled = false; newHeaderComment = ''" class="module_muro__button--cancel">Cancelar</button>
                      <button :disabled="sendingComment" @click="handleEdit(answer);" class="module_muro__button--submit">Publicar</button>
                    </div>
                  </div>
                  <template v-else>
                    <link-preview
                      :editMode="false"
                      :data="answer.link[0]"
                    />
                    <p class="module_muro__childrenComment_content" v-html="answer.comment"></p>
                  </template>
                </div>
              </div>
              <button  
                v-if="comment.comments?.data.length < comment.comments.totalResults"
                class="module_muro__fetchMoreComments"
                style="width: 85%; text-align: center; margin-left: 15%;"
                @click="handleMoreAnswers(idx, idxComment)"
                :disabled="loadingMoreComments[`${idx}--${idxComment}`]"
              >
                {{ $t('moduleMuro.SEE_MORE') }}
              </button>
            </template>

            
          </div>
          
          <button 
          v-if="column.comments.length < column.totalResults" 
          class="module_muro__fetchMoreComments"
          @click="handleMoreComments(idx)"
          :disabled="fetchingComments"
          >
          Ver mas
          </button>
        </div>
      </div>
    </div>

    <div
      class="module_muro-expand"
      v-if="user.permissions.includes('CURSO_ACTIVIDAD_AVANCE') && data.length > 0"
      @click.stop="expandModule = !expandModule"
    >
      <div class="module_muro-expand__line"></div>
      <i class="material-icons">{{expandModule ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
      <div class="module_muro-expand__line"></div>
    </div>

    <Modal 
      v-if="modalDelete" 
      :isOpen="modalDelete" 
      @close="cleanDeleteCommentModel(); modalDelete = false"
    >
      <div class="module_modal__content">
          <div class="module_modal__title">
              <h2>{{ $t('comments.WISH_DELETE_COMMENT') }}</h2>
          </div>
          <div class="module_modal__options">
              <button v-if="deleteCommentModel.parentIdx !== null" class="module_modal__options--cancel" @click="modalDelete = false; cleanDeleteCommentModel()">{{ $t('global.CANCEL') }}</button>
              <button :disabled="deletingComment" v-if="!commentForDelete.isDeleted" class="module_modal__options--deleteOnly" @click.stop="handleDelete(deleteCommentModel.id, deleteCommentModel.idx, deleteCommentModel.headerIdx, deleteCommentModel.parentIdx)">{{ $t('comments.DELETE_COMMENT') }}</button>
              <button :disabled="deletingComment" v-if="deleteCommentModel.parentIdx === null && commentForDelete.repliesQuantity > 0" class="module_modal__options--deleteAll" @click.stop="handleDelete(deleteCommentModel.id, deleteCommentModel.idx, deleteCommentModel.headerIdx, null, true)">{{ $t('comments.DELETE_THREAD') }}</button>
          </div>
      </div>
    </Modal>

  </template>

  <!-- TUTOR DATA -->
  <div class="tutor-view" v-if="user.permissions.includes('CURSO_ACTIVIDAD_AVANCE')">
      <template v-if="resumeLoaded">
          <div class="resume">
              <div class="title" @click.stop="resume.expand ? resume.expand = false : resume.expand = true">
                  <span>{{$t('global.RESUME')}}</span>
                  <i class="material-icons">{{resume.expand ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
              </div>
              <div class="resume-data" v-if="resume.expand">
                  <div>{{ $t('global.PARTICIPANTS') }}   <span>{{resume.totalStudents}}</span></div>
                  <div>{{$t('global.TOTAL_DELIVERED')}}   <span>{{resume.finished}}</span></div>
                  <div>{{ $t('global.DELIVERY_DATE')}}   <span>{{formatDate(resume.endDate)}}</span></div>
                  <div>{{ $t('global.ACTIVITY_STATUS')}} 
                    <span v-if="resume.remainingTimeValue" style="color:#009696">{{ $t('moduleMuro.OPEN') }}</span>
                    <span v-else style="color:#F57055">{{ $t('moduleMuro.EXPIRED') }}</span>
                  </div>
              </div>
          </div>
      </template>
      <template v-if="detailLoaded && user.permissions.includes('CURSO_ACTIVIDAD_AVANCE')">
            <div class="detail">
                <div class="title">
                    <div class="title__span" @click.stop="detail.expand = !detail.expand" >
                        <span>{{$t('global.DETAIL')}}</span>
                        <i class="material-icons">{{detail.expand ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
                    </div>
                    <div v-show="detail.expand" class="details__filter" >
                          <div  class="dropdown" ref="status">
                            <input type="checkbox" id="status">
                            <label class="dropdown__face" for="status">
                                <div class="dropdown__text">{{$t('global.STATE')}}</div>
                                <span class="material-icons">keyboard_arrow_down</span>
                            </label>
                            <ul class="dropdown__items">
                                <template v-for="(state,index) in statusFilters.status" :key="index" >
                                    <li :style="{ 'color': statusFilters.selected === state ? '#000' : '#7D7D7D' }" @click.stop="addStateFilter(state)" >{{ $t(`tutor.detail.status.${state}`) }}</li>
                                </template>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="detail-data" v-if="detail.expand">
                  <div class="table-title">{{$t('global.PARTICIPANT')}}</div>
                  <div class="table-title">{{$t('global.STATUS')}}</div>
                  <div class="table-title">{{$t('global.LAST_MODIFICATION')}}</div>
                  <template v-if="detailValuesLoaded" >
                    <template v-for="(student,index) in detail.data" :key="index">
                        <div class="table-user" @click.stop="router.push(`/course/${route.params.courseId}/module/${route.params.moduleId}/muro/${route.params.muroId}/userHistory/${student.learningUserId}`)">

                            {{student.firstName}} {{student.lastName}}
                        </div>
                        <div class="detail__status">
                            <span :class="{'NotFinished--a': student.status == 'NotFinished', 'FinishedOutOfTime--a': student.status === 'FinishedOutOfTime', 'FinishedInTime--a': student.status === 'FinishedInTime'}">
                                {{$t(`tutor.detail.status.${student.status}`)}}
                            </span>
                            <span v-if="student.status == 'NotFinished'">
                                {{student.timeDiffValue ? $t('global.EXPIRES_IN') + student.timeDiffValue + ' ' + $t(`date.params.${student.timeDiffParam}`) : $t('global.EXPIRED')}}
                            </span>
                            <span v-if="student.status == 'FinishedOutOfTime'">
                                {{student.timeDiffValue + ' ' + $t(`date.params.${student.timeDiffParam}`) + ' ' + $t('global.LATE')}}
                            </span>
                        </div> 
                        <div>{{student.lastSeen ? formatDate(student.lastSeen) : $t('global.NEVER')}}</div>
                    </template>
                  </template>
              </div>
          </div>
      </template>
  </div>

</template>

<script>
import { onMounted, onUnmounted, ref } from 'vue';
import { useRoute, useRouter } from "vue-router";
import { dragscroll } from 'vue-dragscroll'
import { VueEditor} from "vue3-editor";
import { useStore } from 'vuex';
import storage from "@/plugins/azure-storage";
import Loader from '../../components/Loader.vue'
import Modal from '../../components/Modal.vue'
import { onClickOutside } from '@vueuse/core';
import LinkPreview from '@/components/LinkPreview.vue';
import { useI18n } from 'vue-i18n';
import { inject } from "@vue/runtime-core";
import { computed } from 'vue';
import EmptyState from '@/components/EmptyState.vue';




export default {
  directives: {
    dragscroll
  },
  components: {
    VueEditor,
    Loader,
    Modal,
    LinkPreview,
    EmptyState
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const viewComments = ref({})
    const newHeaderComment = ref('')
    const newHeaderLink = ref(null);
    const sendingComment = ref(false)
    const fetchingComments = ref(false)
    const isMobile = ref(window.innerWidth <= 1000)
    const loadingMoreComments = ref({})
    const deletingComment = ref(false)
    const data = ref()
    const dataLoaded = ref(false)
    const moduleLocked = ref(false)
    const moduleLockedDate = ref('')
    const forumData = ref()
    const deleteCommentModel = ref({
      id: null,
      idx: null,
      parentIdx: null,
      headerIdx: null
    })
    const cleanDeleteCommentModel = () => deleteCommentModel.value = { id: null, idx: null, parentIdx: null, headerIdX: null }
    const modalDelete = ref(false)
    const customToolbar = [
      ["bold", "italic", "underline"],
      ["image"]
    ]
    const enableTextBox = ref({})
    const expandModule = ref(false)

    // TUTOR DATA properties and methods from first snippet
    const user = computed(() => store.getters.manageUser_user);
    const resume = ref();
    const detail = ref({
        expand: false,
        data: []
    });
    const resumeLoaded = ref(false);
    const detailLoaded = ref(false);
    const detailValuesLoaded = ref(false)


    const { t } = useI18n();

    const formatDate = inject("formatDate");


    const statusFilters = ref({
        status: ['All'],
        selected: 'All'
    })
    const status = ref(null);


    const getColumns = async () => {
      try {
        const { data: columns } = await store.dispatch('commentsWalls_get', {
          courseId: route.params.courseId,
          contentIdentifier: forumData.value.identifier
        })
        data.value = columns
        dataLoaded.value = true
      } catch (err) {
        console.log(err)
        store.dispatch('notifications_create', { text: t('moduleMuro.ERROR_LOADING_INFORMATION') })
      }
    }

    const handleImageAdded = (file) => console.log(file)

    const handleLike = async (commentid, isLiked, headerIdx) => {
      try {
        // Ya realiza la accion de dar like o dislike en modo visual antes de hacer la peticion al servidor. Si arroja error volvera a su estado principal en CATCH
        data.value[headerIdx].comments.find(comment => comment.id === commentid).isLikedByUser = !isLiked
        isLiked ? data.value[headerIdx].comments.find(comment => comment.id === commentid).likesQuantity-- : data.value[headerIdx].comments.find(comment => comment.id === commentid).likesQuantity++
        isLiked ? await store.dispatch('forum_deleteLikeComment', commentid) : await store.dispatch('forum_postLikeComment', commentid) 
      } catch (err) {
        console.log(err)
        store.dispatch('notifications_create', { text: t('moduleMuro.ERROR_PERFORMING_ACTION') })
        data.value[headerIdx].comments.find(comment => comment.id === commentid).isLikedByUser = isLiked
        isLiked ? data.value[headerIdx].comments.find(comment => comment.id === commentid).likesQuantity++ : data.value[headerIdx].comments.find(comment => comment.id === commentid).likesQuantity--
      }
    }
    
    const convertDataURLToFile = async () => {
      // const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
      
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = newHeaderComment.value;

      const imgElement = tempDiv.querySelector('img');
      const base64Data = imgElement.src.split(',')[1];
      try {
        const binaryString = window.atob(base64Data);
        const byteArray = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          byteArray[i] = binaryString.charCodeAt(i);
        }
  
        const blob = new Blob([byteArray], { type: 'image/png' });
  
        const file = new File([blob], 'png', { type: 'image/png' });
  
        try {
          let fileCDN = await storage.updateFile(file, 'foroComment');
          // imgElement.src = `${process.env.VUE_APP_USERMEDIA_CDN}${process.env.VUE_APP_CDN_FOROCOMMENT_CONTAINERNAME}/${fileCDN}`
          // if (ps-storage)
          let blobPath = process.env.VUE_APP_USERMEDIA_CDN;
          if (process.env.VUE_APP_STORAGE_MODE == 'ps-storage') {
            blobPath = process.env.VUE_APP_PSSTORAGE_URL;
          }

          // Asignamos la ruta final
          imgElement.src = `${blobPath}${process.env.VUE_APP_CDN_FOROCOMMENT_CONTAINERNAME}/${fileCDN}`;


          newHeaderComment.value = tempDiv.innerHTML.toString()
        } catch (err) {
          console.log(err)
        } 
      } catch (err) {
        console.log(err)
        return
      }
    }

    const handleComment = async (headeridx, commentid = null, commentidx = null) => {
      // Si hay un comentario en fila enviandose localmente | el comentario esta vacio, no dejara seguir
      if(sendingComment.value) return
      if (newHeaderComment.value.trim().length === 0) {
        // Si el comentario no tiene nada, devuelve un aviso
        store.dispatch('notifications_create', { text: t('moduleMuro.COMMENT_CANNOT_BE_EMPTY') })
        return
      } else {
        // Si el comentario tiene espacios, revisa el html que genera el editor de texto, y se fija que no haya texto 
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = newHeaderComment.value;
        const content = tempDiv.querySelector('p');
        if (content.innerText.trim() === 0) {
          store.dispatch('notifications_create', { text: t('moduleMuro.COMMENT_CANNOT_BE_EMPTY') })
          return
        }
      }

      try {
        sendingComment.value = true;
        // Verifica si el texto posee una imagen
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = newHeaderComment.value;
        const img = tempDiv.querySelector('img');
        if (img) {
          // Convierte el src de la imagen generada por el editor en un File, y se sube a la cdn 
          await convertDataURLToFile()
        }
        let body = {
          forumHeaderId: data.value[headeridx].header.id,
          comment: newHeaderComment.value,
          relatedCommentId: commentid,
          courseId: route.params.courseId,
          link: newHeaderLink.value ? [newHeaderLink.value] : []
        }
        console.log(body)
        let { data: response } = await store.dispatch('forum_postComment', body);
        if (commentid === null) data.value[headeridx].comments.unshift(response) 
        else {
          data.value[headeridx].comments[commentidx].comments?.data.unshift(response)
          data.value[headeridx].comments[commentidx].repliesQuantity++
        }
        newHeaderComment.value = '';
        newHeaderLink.value = null;

        // Si es exitoso, reiniciar la caja de comentarios
        activeCommentBox.value = null;
      } catch (err) {
        console.log(err)
        store.dispatch('notifications_create', { text: t('moduleMuro.ERROR_SENDING_COMMENT') })
      } finally {
        sendingComment.value = false;
        if (commentidx === null) enableTextBox.value[headeridx] = false
        else enableTextBox.value[`${headeridx}--${commentidx}`] = false

        // Asegurar que la caja se cierre aunque haya error
        activeCommentBox.value = null;
        
      }
    }

    const handleMoreComments = async (headeridx) => {
      if (data.value[headeridx].comments.length === data.value[headeridx].totalResults) return
      if(fetchingComments.value) return
      try { 
        fetchingComments.value = true

        let body = {
          courseId: route.params.courseId,
          headerId: data.value[headeridx].header.id,
          pageNumber: Math.ceil(data.value[headeridx].comments.length / 10),
          rowsPerPage: 10
        }

        let { data: moreComments } = await store.dispatch('forum_comments', body)
        data.value[headeridx].comments.push(...moreComments.comments)
      } catch (err) {
        console.log8(err)
        store.dispatch('notifications_create', { text: t('moduleMuro.ERROR_LOADING_COMMENTS') })
      } finally {
        fetchingComments.value = false
      }
    }

    const fetchCommentsAnswers = async (headerIdx, commentIdx) => {
      if(loadingMoreComments.value[`${headerIdx}--${commentIdx}`]) return
      if (!data.value[headerIdx].comments[commentIdx].comments) {
        try {
          let body = {
            courseId: route.params.courseId,
            commentId: data.value[headerIdx].comments[commentIdx].id,
            rowsPerPage: 10
          }
          loadingMoreComments.value[`${headerIdx}--${commentIdx}`] = true
          let { data: commentAnswers } = await store.dispatch('forum_commentAnswers', body);
          data.value[headerIdx].comments[commentIdx].comments = commentAnswers
          viewComments.value[`${headerIdx}--${commentIdx}`] = true
        } catch (err) {
          console.log(err)
          store.dispatch('notifications_create', { text: 'Ha ocurrido un error cargando la información' })
        } finally {
          loadingMoreComments.value[`${headerIdx}--${commentIdx}`] = false
        }
      }

      else {
        viewComments.value[`${headerIdx}--${commentIdx}`] = viewComments.value[`${headerIdx}--${commentIdx}`] ? false : true
      }
    }

    const handleMoreAnswers = async (headerIdx, commentIdx) => {
      if (loadingMoreComments.value[`${headerIdx}--${commentIdx}`]) return
      if (data.value[headerIdx].comments[commentIdx].comments.data?.length === data.value[headerIdx].comments[commentIdx].comments.totalResults) return
      try {
        loadingMoreComments.value[`${headerIdx}--${commentIdx}`] = true
        let body = {
          courseId: route.params.courseId,
          commentId: data.value[headerIdx].comments[commentIdx].id,
          rowsPerPage: 10,
          pageNumber: Math.ceil(data.value[headerIdx].comments[commentIdx].comments.data.length / 10)
        }
        let { data: commentAnswers } = await store.dispatch('forum_commentAnswers', body);
        data.value[headerIdx].comments[commentIdx].comments.data.push(...commentAnswers.data)
      } catch (err) {
        console.log(err)
        store.dispatch('notifications_create', { text: 'Ha ocurrido un error cargando los comentarios.' })
      } finally {
        loadingMoreComments.value[`${headerIdx}--${commentIdx}`] = false
      }
    }
    

    const handleDelete = async (commentId, commentIdx, headerIdx, parentIdx = null, deleteAll = false) => {
      if (deletingComment.value) return
      try {
        deletingComment.value = true
        let body = {
          commentId,
          courseId: route.params.courseId,
          deleteAll
        }
        await store.dispatch('forum_deleteComment', body);
        if (parentIdx === null) {
          data.value[headerIdx].comments[commentIdx].isDeleted = true
        } else {
          data.value[headerIdx].comments[parentIdx].comments.data[commentIdx].isDeleted = true
          data.value[headerIdx].comments[parentIdx].repliesQuantity--
        }
        
        if (deleteAll) {
          data.value[headerIdx].comments[commentIdx].comments?.data.forEach(comment => comment.isDeleted = true)
        }
      } catch (err) {
        console.log(err)
        store.dispatch('notifications_create', { text: t('moduleMuro.ERROR_DELETING_COMMENT') })
      } finally {
        cleanDeleteCommentModel();
        modalDelete.value = false
        deletingComment.value = false
      }
    }

    const handleEdit = async (comment) => {
      if (sendingComment.value) return
      if (newHeaderComment.value.trim().length === 0) {
        // Si el comentario no tiene nada, devuelve un aviso
        store.dispatch('notifications_create', { text: 'El comentario no puede estar vacío.' })
        return
      } else {
        // Si el comentario tiene espacios, revisa el html que genera el editor de texto, y se fija que no haya texto 
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = newHeaderComment.value;
        const content = tempDiv.querySelector('p');
        if (content.innerText.trim() === 0) {
          store.dispatch('notifications_create', { text: 'El comentario no puede estar vacío.' })
          return
        }
      }

      try {
        sendingComment.value = true
        // Verifica si el texto posee una imagen
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = newHeaderComment.value;
        const img = tempDiv.querySelector('img');
        if (img) {
          // Convierte el src de la imagen generada por el editor en un File, y se sube a la cdn 
          await convertDataURLToFile()
        }
        comment.comment = newHeaderComment.value
        comment.link = newHeaderLink.value ? [newHeaderLink.value] : []
        await store.dispatch('forum_editComment', comment);
      } catch (err) {
        console.log(err)
        store.dispatch('notifications_create', { text: t('moduleMuro.ERROR_EDITING_COMMENT') })
      } finally {
        newHeaderComment.value = ''
        sendingComment.value = false
        comment.editEnabled = false
      }
    }


    // Cambiar enableTextBox a ref que contiene string o nulo
    const activeCommentBox = ref(null);

    // Función para manejar activar una comment box
    const activateCommentBox = (columnIdx, commentIdx = null) => {
      const indexKey = commentIdx !== null ? `${columnIdx}--${commentIdx}` : `${columnIdx}`;
      activeCommentBox.value = activeCommentBox.value === indexKey ? null : indexKey;

      // clean newHeaderComment
      newHeaderComment.value = '';
    };

    const hiddeModalOptions = input => {
      let element = document.getElementById(input)
      element.checked = false
    }

    const addClickOutside = input => {
      let element = document.getElementById(input)
      onClickOutside(element, () => element.checked = false)
    }

    const getInfo = async () => {
      try {
        const { data } = await store.dispatch("courses_contents", route.params.muroId);
        forumData.value = data
        forumData.value.data = JSON.parse(forumData.value.data);
        forumData.value.data.Data = forumData.value.data.Data.replace(/\[BEGIN_(\w*)\]?/g,'').replace(/\[END_(\w*)\]?/g,'');
      } catch (error) {
          if(error.response.data.includes('Content is not open')){
              moduleLockedDate.value = error.response.data.split('_')[1].split(' ')[0];
              moduleLocked.value = true;
          }
      }
    }

    /* TUTOR */
    async function getResume(){
      try {
        let req = await store.dispatch('activities_tutorResume',route.params.muroId);
        resume.value = req.data;
        resume.value.expand = true;
        resumeLoaded.value = true;
        // console.log('resume value is' + JSON.stringify(resume.value))
        // alert('resume value is' + JSON.stringify(resume.value))
      } catch (error) {
        console.log(error);
          store.dispatch('notifications_create', { text: t('forum.errors.LOAD_RESUME')});
      }
    }


    async function getDetail(){
      let prop = {
            contentId: route.params.muroId,
            status: statusFilters.value.selected
        }
        try {
            detailValuesLoaded.value = false
            let req = await store.dispatch('activities_tutorDetail',prop);
            detail.value.data = req.data;
            detailValuesLoaded.value = true
            detailLoaded.value = true;
        } catch (error) {
            console.log(error);
            store.dispatch('notifications_create', { text: t('forum.errors.LOAD_DETAIL')});
        }
    }

    const getStatus = async () => {
        let res = await store.dispatch('activities_submissionsFilters')
        statusFilters.value.status.push(...res.data)
    }

    const addStateFilter = (state) => {
        statusFilters.value.selected = state
        document.getElementById('status').checked = false
        getDetail()
    }

    function tutorReq(){
      getResume();
      getDetail();
    }

    onMounted(async () => {
      await getInfo()
      //if getInfo is successful, get columns, if not, do nothing
      if(forumData.value){
        getColumns()
        getStatus()
      }

      window.addEventListener('resize', () => isMobile.value = window.innerWidth <= 1000)

      // If tutor data needs to be fetched on component mount
      if (user.value.permissions.includes('CURSO_ACTIVIDAD_AVANCE')) {
        tutorReq();
      }
    })

    onUnmounted(() => {
      window.removeEventListener('resize', () => isMobile.value = window.innerWidth <= 1000)
    })


    return {
      route,
      router,
      data,
      enableTextBox,
      customToolbar,
      isMobile,
      dataLoaded,
      handleLike,
      handleComment,
      newHeaderComment,
      sendingComment,
      handleMoreComments,
      fetchingComments,
      viewComments,
      fetchCommentsAnswers, 
      loadingMoreComments,
      hiddeModalOptions,
      addClickOutside,
      handleDelete,
      modalDelete,
      deleteCommentModel,
      cleanDeleteCommentModel,
      deletingComment,
      handleEdit,
      handleMoreAnswers,
      forumData,
      handleImageAdded,
      newHeaderLink,
      activeCommentBox,
      activateCommentBox,
      resume,
      detail,
      resumeLoaded,
      detailLoaded,
      user,
      tutorReq,
      formatDate,
      expandModule,
      statusFilters,
      addStateFilter,
      status,
      detailValuesLoaded,
      moduleLocked,
      moduleLockedDate
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/main.scss';

.module-muro-content{
  font-size: 18px !important;
  *{
    font-size: 18px !important;
  }
}

.module_modal{
  &__content{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    gap: 28px;
    padding-bottom: 18px;
    max-width: 691px;
    width: 60vh;
    @media screen and (max-width: 560px) {
      width: 30vh;
    }
  }
  &__title{
      font-size: 1rem;
    }
  &__options{
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 18px;
      @media screen and (max-width: 560px){
          flex-direction: column;
          gap: 6px;
      }
      &--deleteAll{
          font-weight: 400;
          font-size: 16px;
          color: #fff;
          background-color: $green;
          padding: 12px 24px;
          border-radius: 44px;
          width: 180px;
      }
      &--deleteOnly{
          font-weight: 400;
          font-size: 16px;
          color: $green;
          background-color: inherit;
          border: 1px solid $green;
          padding: 12px 24px;
          border-radius: 44px;
          width: 180px;
      } 
    }
}

.goToModule{
  display: flex;
  align-items: center;
  gap: 6px;
  color: $green !important;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  .material-icons-outlined{
    font-size: 18px;
    width: fit-content;
  }
}


.module{
  &_muro_container {
    overflow: auto;
    overflow-y: hidden;
    &::-webkit-scrollbar-track {
      border-radius: 100px;
      background-color: rgba(0,0,0,.1);
    }
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 100px;
      background: map-get($dark, 400);
      position: absolute;
      border: 4px solid rgba(0, 0, 0, 0);
    }
    .module_muro:nth-child(1) {
      height: fit-content;
      .module_muro__column {
          height: auto;
      }
      .module_muro__header {
        display: flex;
        flex-direction: column;
        justify-content: center;height: 100%;
      }
    }
  }
  &_muro{
    // display: grid;
    // column-gap: 18px;
    overflow: visible;
    padding-bottom: 6px;
    height: 70vh;
    margin-top: 18px;

    display: flex;
    gap: 18px;
    .dropdown{
    width: fit-content;


    &__face{
        padding: 0;
        border-radius:0;
        border: none;
        width: fit-content
    }
    &__items{
        top: 0;
        left: 100%;
        flex-direction: row;
        width: 0;
        padding:0;
        visibility: hidden;
        li{
            font-size: 17px;
        }
    }
    input {
        display: none;
        &:checked ~ .dropdown__items {
        top: calc(100% + -28px);
        visibility: visible;
        left: -420%;
        padding: 10px;
        width: fit-content;
        opacity: 1;
        }
      }
    }
    &::-webkit-scrollbar-track {
      border-radius: 100px;
      background-color: rgba(0,0,0,.1);
    }
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 100px;
      background: map-get($dark, 400);
      position: absolute;
      border: 4px solid rgba(0, 0, 0, 0);
    }
    &__fetchMoreComments{
      font-weight: 600;
      font-size: 18px;
      margin: 12px 0;
      color: $green;
    }
    &__button{
      font-size: 16px;
      font-weight: 600;
      outline: none;
      padding: 12px 0;
      &--cancel{
        @extend .module_muro__button;
        color: $green;
      }
      &--submit{
        @extend .module_muro__button;
        background-color: $green;
        color: #fff;
        width: 165px;
        border-radius: 44px;
      }
    }
    .quillWrapper{
      .ql-toolbar{
        background-color: #fff;
      }
      .ql-container{
        background-color: #fff;
        height: fit-content;
      }
    }
    &__title{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 12px 0;
      @media (max-width: 700px){
        flex-direction: column;
      }
      &-activity{
        font-size: 22px;
        font-weight: 700;
      }
      &-date{
        display: flex;
        align-items: center;
        font-size: 13px;
        font-weight: 600;
        gap: 16px;
        span {
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .material-icons-outlined{
          font-size: 18px;
        }
      }
    }
    &__column{
      display: flex;
      flex-direction: column;
      gap: 18px;
      width: 100%;
      min-width: 280px;
      max-height: 70vh;
      padding-top: 12px;
      padding-right: 4px;
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;

      @media (min-height: 800px){
        max-height: 77vh;
      }
      &::-webkit-scrollbar-track {
        border-radius: 100px;
        background-color: rgba(0,0,0,.1);
      }
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 100px;
        background: map-get($dark, 400);
        position: absolute;
        border: 4px solid rgba(0, 0, 0, 0);
      }
    }
    &__header{
      color: $green;
      font-size: 16px;
      font-weight: 700;
      width: 100%;
      padding: 12px 0;
      border: 2px solid $green;
      border-radius: 10px;
      text-align: center;
    }
    &__addComment{
      display: flex;
      align-items: center;
      gap: 6px;
      color: $green;
      font-size: 16px;
      font-weight: 600;
      align-self: center;
      .material-icons{
        font-size: 18px;
      }
    }
    &__comment{
      padding: 18px 16px;
      border-radius: 10px;
      background-color: #f6f6f6;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
    &__name{
      font-size: 14px;
      font-weight: 400;
      color: #7D7D7D;
      strong{
        font-weight: 600;
        color: $green;
      }
    }
    &__image{
      width: 100%;
      max-height: 285px;
    }
    &__content{
      font-weight: 400;
      font-size: 18px;
      img{
        max-width: 100%;
        border-radius: 10px;
      }
      &--deleted{
        font-weight: 400;
        font-size: 13px;
        color: #7D7D7D;
        //text-align: center;
      }
    }
    &__buttons{
      display: flex;
      align-items: center;
      gap: 12px;
      margin: 12px 0;
      padding-left: 12px;
      &:disabled{
        cursor: pointer;
        opacity: .6;
      }
      &--active{
        font-weight: 600;
        font-size: 10px;
        display: flex;
        align-items: center;
        gap: 8px;
        color: $green !important;
        .material-icons-outlined{
          font-size: 16px;
          color: $green;
        }
      }
      button{
        font-weight: 600;
        font-size: 10px;
        display: flex;
        align-items: center;
        gap: 4px;
        color: #000;
        .material-icons-outlined{
          font-size: 16px;
        }
      }
    }
    &__childrenComment{
      width: 100%;
      display: flex;
      align-items: flex-start;
      position: relative;
      &_lines{
        height: 100%;
        width: 15%;
        padding-left: 12px;
      }
      &_line1{
        width: calc(15% - 12px);
        height: 50%;
        position: absolute;
        border-bottom: 1px solid #D2D2D2;
        border-left: 1px solid #D2D2D2;
      }
      &_line2{
        width: calc(15% - 12px);
        height: 100%;
        position: absolute;
        border-left: 1px solid #D2D2D2;
      }
      &_container{
        width: 85%;
        background-color: #F6F6F6;
        padding: 12px 18px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
      &_name{
        font-size: 14px;
        font-weight: 400;
        color: #7D7D7D;
        strong{
          font-weight: 600;
          color: $green;
        }
      }
      &_content{
        font-size: 16px;
        font-weight: 400;
        img{
          max-width: 100%;
        }
      }
    }
  }
}



.module_muro_container--tutor {
    height: 200px;
    position: relative;

    .module_muro__column {
      overflow: hidden;
    }

    &::after {
      // gradient overlay bottom 50px height
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 50px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);

    }

    &--expanded {
      height: 82vh;

      &::after {
        display: none;
      }

      .module_muro__column {
        overflow: auto;
      }
    }
}
.module_muro-expand {
    color: $green;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    cursor: pointer;
    text-align: center;
    padding: 16px 0;

  .material-icons-outlined{
    font-size: 18px;
  }
  &__line {
    width: 100%;
    height: 1px;
    background-color: #DBDBDB;
  }
}


.commentsWall {
    &__swipe {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 0;
        i {
            font-size: 24px;
            color: $green;
        }
        span {
            font-weight: 700;
            color: $black;
        }
    }
}







.tutor-view{
    padding-bottom: 24px;
    margin-bottom: 32px;
    //border-bottom: 1px solid #eee;
    .title{
        width: 100%;
        display: flex;
        align-items: center;
        // justify-content: flex-start;
        gap: 4px;
        color: $green;
        font-size: 16px;
        font-weight: 700;
        cursor: pointer;
        &__span{
            display: flex;
            align-items: center;
        }
    }
    .resume .title {
      justify-content: flex-start;
    }
    .detail .title {
      justify-content: space-between;
    }
    .resume,.detail{
        &-data{
            padding: 16px;
            margin-top: 12px;
            background: inherit;
            box-shadow: 0px 4px 4px #00000040;
            border-radius: 8px;
        }
    }

    .detail{
        &-data{
            width: 100%;
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            overflow: auto;
            gap: 16px;
            div{
                @include flex-column;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                font-size: 14px;
                margin-bottom: 10px;
                @media screen and (max-width: $bpSmall){
                    font-size: 12px;
                }
            }
            .table-title{
                font-weight: 600;
                FONT-SIZE: 14px;
            }
            .table-user{
                cursor: pointer;
                color: map-get($dark, 800);
                font-weight: 700;
            }
        }
        &__status{
            flex-direction: row;
            span:nth-child(2){
                font-size: 12px;
                font-weight: 400;
                margin-left: 12px;
                @media screen and (max-width: $bpSmall){
                    font-size: 8px;
                }
            }
        }
        &__lastModification{
            color: map-get($dark, 800)
        }
    }
    .resume{
        margin-bottom: 24px;
        &-data{
            display: grid;
            grid-template-columns: auto auto;
            gap: 16px;
            font-weight: 600;
            font-size: 14px;
            overflow-x: auto;
            color: #000;

            span{
                font-weight: 400;
                margin-left: 6px;
            }
        }
    }
}

#emoji-close-div { z-index:0; }

@media screen and (max-width: $bpBig){
.tutor-view{
    .resume-data{
      grid-template-columns: auto;
    }
  }
  .select-header{
    text-align: center;
    .item{
        align-items: center;
    }
}
}

</style>